module.exports = __webpack_public_path__ + "static/media/gender_based_violence_blue.eff7f99e.svg";